import React from 'react';
import styled from 'styled-components';
import { greenColor } from 'js/config/style';
import { formatCurrency } from 'js/services/Format';

const Container = styled.div`
  grid-area: price;
  padding-top: 1rem;
  color: ${greenColor};
  font-weight: 500;
`;

export default ({ children: price }) => <Container>{formatCurrency(price)}</Container>;
